// @ts-nocheck

import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';

import { FlashMessageSeverities } from '../../types/flashmessage';
import { type FlashMessageSeverity } from '../../types/flashmessage';

const fadeIn = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const Wrapper = styled.button`
  &&&& {
    padding: 10px;
    margin: 10px 0;
    background: ${({ $severity, theme }) => {
      if ($severity === FlashMessageSeverities.NOTICE) return theme.common.colors.positive;
      if ($severity === FlashMessageSeverities.WARNING) return theme.common.colors.secondary;
      if ($severity === FlashMessageSeverities.ERROR) return theme.common.colors.negative;
      return theme.common.colors.mild;
    }};
    transition:
      transform 300ms ease-out,
      opacity 300ms ease-out;
    transform: ${({ $loaded }) => ($loaded ? 'none' : 'translateY(100px)')};
    opacity: 1;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: solid 1px #fff;
    border-radius: 0;
    animation: ${fadeIn} 1s ease-in forwards;
    animation-delay: 5s;
    text-align: right;
    width: 100%;
  }
`;

const browsersAnimationEndEvent = ['webkitAnimationEnd', 'mozAnimationEnd', 'animationend'];

type FlashMessageProps = {
  severity: FlashMessageSeverity;
  handleClick: () => void;
  children: React.ReactNode;
  handleDelete: () => void;
};

const FlashMessage = ({ severity, handleClick, children, handleDelete }: FlashMessageProps) => {
  const node = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
    const currNode = node?.current;

    browsersAnimationEndEvent.forEach((event) => {
      if (currNode) {
        currNode.addEventListener(`${event}`, handleDelete);
      }
    });

    return () => {
      browsersAnimationEndEvent.forEach((event) => {
        if (currNode) {
          currNode.addEventListener(`${event}`, handleDelete);
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper ref={node} $loaded={loaded} $severity={severity} onClick={handleClick}>
      {children}
    </Wrapper>
  );
};

export default FlashMessage;
